(function () {
  'use strict';

  var store = window.WmpStore;
  var router = window.WmpRouter;
  var MOBILE_HELP_ID = 'wmp-mobile-help-rx-type-extra';

  function getLabel(root, attr, fallback) {
    return (root && root.getAttribute(attr)) || fallback;
  }

  function getDescription(root, attr, fallback) {
    var value = root ? root.getAttribute(attr) : '';
    return value && value.trim() ? value : fallback;
  }

  function buildTypes() {
    var root = document.getElementById('wmp-prescription-flow');
    return [
      {
        key: 'single-vision',
        name: getLabel(root, 'data-rx-label-single-vision', 'SINGLE VISION'),
        description: getDescription(root, 'data-rx-description-single-vision', 'Clear vision at one distance, reading, computer, or everyday wear.')
      },
      {
        key: 'reading',
        name: getLabel(root, 'data-rx-label-reading', 'READING'),
        description: getDescription(root, 'data-rx-description-reading', 'Designed for close-up tasks like reading or phone use.')
      },
      {
        key: 'progressive',
        name: getLabel(root, 'data-rx-label-progressive', 'PROGRESSIVE'),
        description: getDescription(root, 'data-rx-description-progressive', 'Distance and reading correction in one lens, no visible lines.')
      },
      {
        key: 'non-prescription',
        name: getLabel(root, 'data-rx-label-non-prescription', 'NON-PRESCRIPTION'),
        description: getDescription(root, 'data-rx-description-non-prescription', 'Plano lenses with no vision correction.')
      }
    ];
  }

  var advanceTimer = null;

  function render(container) {
    var currentType = store.get('prescriptionType');
    var root = document.getElementById('wmp-prescription-flow');
    var questionIconUrl = root ? root.getAttribute('data-question-icon') : '';
    var infoIconHtml = questionIconUrl
      ? '<img src="' + questionIconUrl + '" alt="" aria-hidden="true" width="16" height="16" loading="eager">'
      : '?';

    // Heading row
    var header = document.createElement('div');
    header.style.cssText = 'display:flex;justify-content:space-between;align-items:baseline;flex-wrap:wrap;gap:8px;margin-bottom:20px;';
    header.className = 'desktop-only';
    var heading = document.createElement('h2');
    heading.className = 'wmp-flow__step-heading';
    heading.textContent = store.getStepHeading('prescription-type');
    heading.style.marginBottom = '0';
    header.appendChild(heading);

    var helpLink = document.createElement('button');
    helpLink.className = 'wmp-help-link-wrapper';
    helpLink.innerHTML = `<span class="wmp-help-link">
      Learn about different lens usages</span><span class="wmp-card__info" aria-hidden="true">
        ${infoIconHtml}
      </span>`;
    helpLink.addEventListener('click', onHelpClick);
    // Do not show hover tooltip — open full modal on click only.
    header.appendChild(helpLink);

    container.appendChild(header);

    // Card list
    var list = document.createElement('div');
    list.className = 'wmp-card-list';

    var types = buildTypes();
    for (var i = 0; i < types.length; i++) {
      var type = types[i];
      var card = document.createElement('button');
      card.className = 'wmp-card';
      card.setAttribute('type', 'button');
      card.setAttribute('data-value', type.key);

      if (currentType === type.key) {
        card.classList.add('wmp-card--selected');
      }

      var content = document.createElement('div');
      content.className = 'wmp-card__content';

      var title = document.createElement('span');
      title.className = 'wmp-card__title';
      title.textContent = type.name;
      content.appendChild(title);

      var desc = document.createElement('span');
      desc.className = 'wmp-card__description';
      desc.textContent = type.description;
      content.appendChild(desc);

      card.appendChild(content);

      card.addEventListener('click', onCardClick);
      list.appendChild(card);
    }

    container.appendChild(list);

    renderMobileStepHelp(infoIconHtml);
  }

  function renderMobileStepHelp(infoIconHtml) {
    removeMobileStepHelp();
    var mobileStepInfo = document.getElementById('wmp-mobile-step-info');
    if (!mobileStepInfo) return;

    var mobileHelp = document.createElement('button');
    mobileHelp.className = 'wmp-help-link-wrapper';
    mobileHelp.id = MOBILE_HELP_ID;
    mobileHelp.type = 'button';
    mobileHelp.innerHTML =
      '<span class="wmp-help-link">Learn about different lens usages</span>' +
      '<span class="wmp-card__info" aria-hidden="true">' + infoIconHtml + '</span>';
    mobileHelp.addEventListener('click', onHelpClick);
    // Mobile: rely on click to open the modal; no hover behavior.
    mobileStepInfo.appendChild(mobileHelp);
  }

  function removeMobileStepHelp() {
    var existing = document.getElementById(MOBILE_HELP_ID);
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }
  }

  function onCardClick(e) {
    var card = e.currentTarget;
    var value = card.getAttribute('data-value');

    // Update visual selection
    var cards = card.parentNode.querySelectorAll('.wmp-card');
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.remove('wmp-card--selected');
    }
    card.classList.add('wmp-card--selected');

    // Update store
    store.set('prescriptionType', value);

    // Auto-advance after brief delay for visual feedback
    if (advanceTimer) clearTimeout(advanceTimer);
    advanceTimer = setTimeout(function () {
      router.advance();
    }, 200);
  }

  function onHelpClick() {
    // Prefer centralized opener exposed on WmpApp, fallback to WmpModal
    if (window.WmpApp && typeof window.WmpApp.openLensUsagesModal === 'function') {
      try { window.WmpApp.openLensUsagesModal(); } catch (e) { /* ignore */ }
      return;
    }

    var i18n = window.WmpI18n || {};
    var modals = i18n.modals || {};
    if (window.WmpModal && typeof window.WmpModal.open === 'function') {
      window.WmpModal.open({
        title: modals.lens_usages_title || 'Lens Usages',
        content: modals.lens_usages || '',
        size: 'md'
      });
    }
  }

  function destroy() {
    removeMobileStepHelp();
    if (advanceTimer) {
      clearTimeout(advanceTimer);
      advanceTimer = null;
    }
  }

  window.WmpSteps = window.WmpSteps || {};
  window.WmpSteps['prescription-type'] = {
    render: render,
    destroy: destroy,
    // Single source of truth for labels — consumed by wmp-step-review.js
    types: buildTypes
  };
})();
